export const RESOURCES_MODULE_NAME = '@pressreader/resources';
